import React from 'react';

const ComingSoon = () => {
    return (
        <div className='coming-soon'>
            <h1 style={{ 
                textAlign: 'center',
                fontSize: '30px',
                fontWeight: 'bold',
                color: '#fff',
             }}>
                A venir
            </h1>
        </div>
    );
};

export default ComingSoon;